export class FinanceInvoiceDialogModel {
    constructor(
        public id: any
    ) {}
}